<template>
  <div>
    <div class="has-loader">
      <div class="loader" :class="{ loaded: !processing }">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
      <inputbox
        name="vehicle_registration"
        :stacked="stacked"
        v-model="vrm"
        :label="label"
        :helper="helper"
      >
        <div slot="rightBtn">
          <button
            class="btn btn-primary"
            type="button"
            v-on:click.prevent="findVehicle"
          >
            Find Vehicle
          </button>
        </div>
      </inputbox>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    registration: String,
    required: Boolean,
    stacked: Boolean,
    showError: Boolean,
    errorMessage: String,
    helper: String
  },

  data() {
    return {
      vrm: this.registration ? this.registration : null,
      processing: false
    };
  },

  methods: {
    findVehicle() {
      if (!this.vrm) {
        window.swal(
          'Error',
          'You must provide a vehicle registration.',
          'error'
        );
      } else {
        this.vrm = this.vrm.replace(/\s+/g, '');

        if (this.vrm.length > 7) {
          window.swal(
            'Error!',
            'That vehicle registration is too long - please ensure there are no spaces.',
            'error'
          );
          return;
        }

        this.processing = true;

        window.Ajax.get(`/vehicle-registration?registration=${this.vrm}`, false)
          .then(response => {
            this.$emit('vehicle', response.data);
            this.processing = false;
          })
          .catch(error => {
            window.swal('Oops...', "We couldn't find that vehicle!", 'error');
            this.processing = false;
          });
      }
    }
  },

  watch: {
    vrm(newValue) {
      this.vrm = newValue.toUpperCase();
      this.$emit('vrm', this.vrm);
    },

    registration(value) {
      this.vrm = value;
    }
  }
};
</script>
